import Comment from '@/models/Comment'
import Api from '@/api'
import { each, find, findIndex } from 'lodash'

export default {
  namespaced: true,
  state: {
    list: [],
    listMeta: {},
    replyList: [],
    replyListMeta: {}
  },

  mutations: {
    setCommentList(state, comments) {
      each(comments, comment => {
        const exist = find(state.list, { id: comment.id })
        if (!exist) {
          comment._isReplying = false
          comment._replies = []
          comment._repliesMeta = {}
          state.list.push(new Comment(comment))
        }
      })
    },

    setCommentListMeta(state, meta) {
      state.listMeta = meta
    },

    setCommentListItemDetails(state, comment) {
      const index = findIndex(state.list, { id: comment.id })
      state.list[index].body = comment.body
    },

    clearCommentList(state) {
      state.list = []
      state.listMeta = {}
    },

    setReplyList(state, replies) {
      each(replies, reply => {
        const exist = find(state.list, { id: reply.id })
        if (!exist) {
          state.replyList.push(new Comment(reply))
        }
      })
    },

    setReplyListMeta(state, meta) {
      state.replyListMeta = meta
    },

    clearReplyList(state) {
      state.replyList = []
      state.replyListMeta = {}
    },

    clearCommentListItemDetails(state, id) {
      const index = findIndex(state.list, { id: id })
      state.list.splice(index, 1)
    }
  },

  actions: {
    async getComments({ commit }, params) {
      const { data } = await Api.get(
        `jobs/${params.job_id}/comments?include[]=author`
      )
      commit('setCommentList', data.data)
      commit('setCommentListMeta', data.meta)
    },

    async createComment({ commit, state }, formData) {
      const { data } = await Api.post(
        `jobs/${formData.job_id}/comments`,
        formData
      )
      data.data._isReplying = false
      data.data._replies = []
      state.list.unshift(new Comment(data.data))
    },

    async updateComment({ commit, state }, formData) {
      const { data } = await Api.put(`comments/${formData.id}`, formData)
      commit('setCommentListItemDetails', data.data)
    },

    async createReply({ commit, state }, formData) {
      await Api.post(`comments/${formData.id}/responses`, formData)
    },

    async getReplies({ commit }, params) {
      const { data } = await Api.get(`comments/${params.id}/responses`)
      commit('setReplyList', data.data)
      commit('setReplyListMeta', data.meta)
    },

    async deleteComment({ commit, state }, id) {
      await Api.delete(`comments/${id}`)
      commit('clearCommentListItemDetails', id)
    }
  }
}
